<p>shock-angle works!</p>
